// extracted by mini-css-extract-plugin
export default {"head":"Head_head__CWczO","list":"Head_list__FJAod","item":"Head_item__0MleS"};